<script setup>
import { computed } from 'vue'
import FlagIcon from './FlagIcon.ce.vue'
import { useGameStore, MAX_FLAGS } from '../stores/game'

const props = defineProps({
  player: { type: String, required: true },
  right: { type: Boolean, default: false },
})

const store = useGameStore()
const playerData = computed(() => store.player(props.player))

function onFlagClick(index) {
  if (index < playerData.value.flags.length) {
    store.selectFlag(props.player, index)
  }
}

function isActive(index) {
  return store.activeFlagPlayer === props.player && store.activeFlagIndex === index
}
</script>

<template>
  <div class="player-side" :class="{ right }">
    <div class="player-info">
      <div class="vlaggen-count">{{ playerData.flags.length }} / {{ MAX_FLAGS }} vlaggen</div>
      <div class="player-name">{{ playerData.name }}</div>
      <div class="flags-row">
        <FlagIcon
          v-for="i in MAX_FLAGS"
          :key="i"
          :color="playerData.color"
          :won="i <= playerData.flags.length"
          :active="isActive(i - 1)"
          :filterId="`wave-${player}-${i}`"
          :style="i <= playerData.flags.length ? 'cursor: pointer' : ''"
          @click="onFlagClick(i - 1)"
        />
      </div>
    </div>
    <component
      :is="playerData.imageUrl ? 'img' : 'div'"
      class="player-avatar"
      :class="player"
      v-bind="playerData.imageUrl ? { src: playerData.imageUrl, alt: playerData.name } : {}"
    >
      <template v-if="!playerData.imageUrl">{{ playerData.name.charAt(0).toUpperCase() }}</template>
    </component>
  </div>
</template>

<style scoped>
.player-side {
  display: flex;
  align-items: center;
  gap: 2cqi;
  z-index: 1;
}

.player-side.right {
  flex-direction: row-reverse;
}

.player-info {
  text-align: right;
}

.player-side.right .player-info {
  text-align: left;
}

.vlaggen-count {
  font-family: var(--font-heading);
  font-size: 2.5cqi;
  letter-spacing: 0.1em;
  opacity: 0.8;
  margin-bottom: 0.2cqi;
  text-transform: uppercase;
}

.player-name {
  font-family: var(--font-heading);
  font-size: 5cqi;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1;
  margin-bottom: 0.5cqi;
}

.player-avatar {
  height: 18cqi;
  width: auto;
  flex-shrink: 0;
}

.flags-row {
  display: grid;
  grid-template-columns: repeat(5, 3.2cqi);
  gap: 0.15cqi;
  justify-content: end;
}

.player-side.right .flags-row {
  justify-content: start;
}

@media (max-width: 600px) {
  .player-side {
    flex-direction: row-reverse;
  }

  .player-side.right {
    flex-direction: row;
  }

  .player-name {
    font-size: 7cqi;
  }

  .vlaggen-count {
    font-size: 2cqi;
  }

  .flags-row {
    grid-template-columns: repeat(5, 3.5cqi);
    gap: 0.3cqi;
  }

  .vlaggen-count {
    font-size: 2.8cqi;
  }

  .player-info {
    z-index: 1;
  }
}
</style>
